<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card style="padding-bottom: 200px">
        <v-toolbar
            dark
            color="primary"
        >
          <v-toolbar-title>
            <span style="font-weight: bold">PROFILE (ข้อมูลส่วนตัว)</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-list>
          <v-list-item style="top: 100px">
            <v-row class="d-flex justify-center">
              <v-col
                  raised
                  cols="12"
                  md="4">
                <v-card>
                  <div
                      class="white--text align-end"
                      style="height: 200px;background-color: lightskyblue"
                  >
                    <v-list-item
                        style="top: -80px"
                        class="justify-center"
                    >
                      <v-avatar
                          size="200"
                          style="border: darkcyan 4px solid"
                      >
                        <img
                            :src="mednet"
                            alt="-"
                        >
                      </v-avatar>
                    </v-list-item>
                  </div>
                  <v-list-item
                      style="top: -50px"
                      class="justify-center"
                  >
                            <span style="font-weight: bold;font-size: 25px" v-if="MeData.length > 0">
                                {{ MeData[0].full_Name }}
                            </span>
                  </v-list-item>
                  <v-list-item
                      class="start"
                  >
                            <span style="font-weight: bold;color: #ff6d81">
                                สังกัด
                            </span>
                    <span v-if="MeData.length > 0">: {{ MeData[0].dep_name }}</span>
                  </v-list-item>
                  <v-list-item
                      class="start"
                  >
                            <span style="font-weight: bold;color: #ff6d81">
                                ตำแหน่ง
                            </span>
                    <span v-if="MeData.length > 0">: {{ MeData[0].pos_name }}</span>
                  </v-list-item>
                  <v-list-item
                      class="start"
                  >
                            <span style="font-weight: bold;color: #ff6d81">
                                อายุงาน
                            </span>
                    <span v-if="workAge.length > 0" style="margin-left: 10px">: {{ workAge[0] }} ปี {{ workAge[1] }} เดือน {{ workAge[2] }} วัน</span>
                  </v-list-item>
                  <v-list-item
                      class="start"
                  >
                            <span style="font-weight: bold;color: #ff6d81" v-if="MeData.length > 0">
                                ระดับ
                            </span>
                    <span style="margin-left: 10px"
                          v-if="level.length > 0">: {{ level[0].LevelName }}</span>
                  </v-list-item>
                  <v-list-item
                      class="start"
                  >
                                    <span style="font-weight: bold;color: #ff6d81" v-if="MeData.length > 0">
                                งบพัฒนาตนเองใช้ไป
                            </span>
                    <span style="margin-left: 10px">: -</span>
                  </v-list-item>
                  <v-list-item
                      class="start"
                  >
                            <span style="font-weight: bold;color: #ff6d81" v-if="MeData.length > 0">
                                งบพัฒนาตนเองคงเหลือ
                            </span>
                    <span style="margin-left: 10px">: -</span>
                  </v-list-item>
                </v-card>
                <v-divider>

                </v-divider>
                <v-card style="top: 20px">
                  <v-toolbar dark color="#64B5F6">
                    <v-toolbar-title>
                      การเลื่อนขั้น
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text style="top: 10px" class="text-center">
                    <span style="color: #364eff;font-weight: bold;text-align: center;width: 100%;font-size: 25px">Coming Soon</span>
                  </v-card-text>
                  <!-- <v-list-item
                           class="start"
                   >
               <span style="font-weight: bold;color: #ff6d81">
                   ระดับขั้นถัดไป
               </span>
                       : ชำนาญการพิเศษ
                   </v-list-item>
                   <v-list-item
                           class="start"
                   >
                       <p style="font-weight: bold;color: #ff6d81">
                           หลักสูตร: <span style="color: darkblue"> 4 หลักสูตร</span> ( <span
                               style="color: darkseagreen"> ผ่าน 2 </span> , <span style="color: crimson"> ขาด 2 </span>)
                       </p>
                   </v-list-item>
                   <v-divider></v-divider>
                   <v-list-item
                           class="start"
                   >
                       <p style="font-weight: bold;color: #ff6d81">
                           คิดเป็นเป็นเซ็นต์ : <span style="color: darkblue">50 %</span>
                       </p>
                   </v-list-item>
                   <v-list-item style="top: 20px;">
                       <v-slider
                               v-model="bpm"
                               :color="color"
                               track-color="grey"
                               always-dirty
                               min="0"
                               max="100"
                               thumb-label="always"
                       >
                           <template v-slot:prepend>
                           <span style="font-weight: bold;color: darkblue">
                               0%
                           </span>
                           </template>

                           <template v-slot:append>
                           <span style="font-weight: bold;color: darkblue">
                               100%
                           </span>
                           </template>
                       </v-slider>
                   </v-list-item>-->
                </v-card>

              </v-col>
              <v-col
                  cols="12"
                  md="7">
                <v-card>
                  <v-toolbar dark color="#64B5F6">
                    <v-toolbar-title>
                      ประวัติการอบรม
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text style="top: 10px" class="text-center">
                    <!--<v-tabs
                            v-model="tabsModel"
                            centered
                            slider-color="yellow"
                    >
                        <v-tab>
                            ประวัติการฝึกอบรม
                        </v-tab>
                        <v-tab>
                            การฝึกอบรมต่อระดับตำแหน่ง
                        </v-tab>
                        <v-tabs-items v-model="tabsModel">
                            <v-tab-item>
                                <v-data-table
                                        :headers="headers"
                                        :items="ProjectRecordData"
                                        class="elevation-1"
                                >
                                    <template v-slot:header.courseName>
                                        <span style="color: black;font-weight: bold;font-size: 20px">หลักสูตร</span>
                                    </template>
                                    <template v-slot:header.credit>
                                        <span style="color: black;font-weight: bold;font-size: 20px">จำนวนเครดิต</span>
                                    </template>
                                    <template v-slot:header.date>
                                        <span style="color: black;font-weight: bold;font-size: 20px">วันที่</span>
                                    </template>
                                </v-data-table>
                            </v-tab-item>
                            <v-tab-item>
                                <v-list-item>
                                    <div>
                                        <v-treeview
                                                :items="level_position"
                                                :dense="dense"
                                                :selectable="selectable"
                                                :activatable="activatable"
                                                :hoverable="hoverable"
                                                :open-on-click="openOnClick"
                                                :selected-color="selectedColor"
                                                :color="color"
                                                :shaped="shaped"
                                                :rounded="rounded"
                                        >
                                            &lt;!&ndash; <template slot="append" slot-scope="{ item }">
                                                 <v-btn @click="addChild(item);">Add child</v-btn>
                                             </template>&ndash;&gt;
                                            <template slot="label" slot-scope="{ item }">
                                                <span v-html='item.name'> </span>

                                                <v-btn class="mx-5" tile dark x-small color="red"
                                                       @click="DeleteItem(item)" icon>
                                                    <v-icon dark>mdi-close</v-icon>
                                                </v-btn>

                                            </template>
                                        </v-treeview>
                                        &lt;!&ndash;                                                        <v-treeview&ndash;&gt;
                                        &lt;!&ndash;                                                                :items="items"&ndash;&gt;
                                        &lt;!&ndash;                                                                :dense="dense"&ndash;&gt;
                                        &lt;!&ndash;                                                                :selectable="selectable"&ndash;&gt;
                                        &lt;!&ndash;                                                                :activatable="activatable"&ndash;&gt;
                                        &lt;!&ndash;                                                                :hoverable="hoverable"&ndash;&gt;
                                        &lt;!&ndash;                                                                :open-on-click="openOnClick"&ndash;&gt;
                                        &lt;!&ndash;                                                                :selected-color="selectedColor"&ndash;&gt;
                                        &lt;!&ndash;                                                                color="primary"&ndash;&gt;
                                        &lt;!&ndash;                                                                :shaped="shaped"&ndash;&gt;
                                        &lt;!&ndash;                                                                :rounded="rounded"&ndash;&gt;
                                        &lt;!&ndash;                                                        >&ndash;&gt;
                                        &lt;!&ndash;                                                            &lt;!&ndash; <template slot="append" slot-scope="{ item }">&ndash;&gt;
                                        &lt;!&ndash;                                                                 <v-btn @click="addChild(item);">Add child</v-btn>&ndash;&gt;
                                        &lt;!&ndash;                                                             </template>&ndash;&gt;&ndash;&gt;
                                        &lt;!&ndash;                                                            <template slot="label" slot-scope="{ item }">&ndash;&gt;
                                        &lt;!&ndash;                                                                <div v-if="item.header">&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span v-if="item.id == '0'"&ndash;&gt;
                                        &lt;!&ndash;                                                                          style="font-weight: bold;color: #42b983">{{item.name}}</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span v-if="item.id != '0'"&ndash;&gt;
                                        &lt;!&ndash;                                                                          style="font-weight: bold">{{item.name}}</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                </div>&ndash;&gt;
                                        &lt;!&ndash;                                                                <div v-else-if="item.subheader"&ndash;&gt;
                                        &lt;!&ndash;                                                                     style="font-weight: bold;color: #42b983">&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span>{{item.name}}</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                    จำนวน 4 เครดิต&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span style="font-weight: bold;color: blue;margin-left: 10px">ผ่าน 2 เครดิต</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span style="font-weight: bold;color: #ff6d81;margin-left: 10px">คงเหลือ 2 เครดิต</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                </div>&ndash;&gt;
                                        &lt;!&ndash;                                                                <div v-else>&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span v-if="item.id == '0'"&ndash;&gt;
                                        &lt;!&ndash;                                                                          style="font-weight: bold;color: #42b983">{{item.name}} จำนวน 2 เครดิต</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span v-if="item.id == '0'"&ndash;&gt;
                                        &lt;!&ndash;                                                                          style="font-weight: bold;color: blue;margin-left: 10px">ผ่าน 2 เครดิต</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span v-if="item.id == '0'"&ndash;&gt;
                                        &lt;!&ndash;                                                                          style="font-weight: bold;color: #ff6d81;margin-left: 10px">คงเหลือ 0 เครดิต</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span v-if="item.id == '1'"&ndash;&gt;
                                        &lt;!&ndash;                                                                          style="font-weight: bold;color: crimson">{{item.name}} จำนวน 2 เครดิต</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span v-if="item.id == '1'"&ndash;&gt;
                                        &lt;!&ndash;                                                                          style="font-weight: bold;color: blue;margin-left: 10px">ผ่าน 0 เครดิต</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                    <span v-if="item.id == '1'"&ndash;&gt;
                                        &lt;!&ndash;                                                                          style="font-weight: bold;color: #ff6d81;margin-left: 10px">คงเหลือ 2 เครดิต</span>&ndash;&gt;
                                        &lt;!&ndash;                                                                </div>&ndash;&gt;
                                        &lt;!&ndash;                                                            </template>&ndash;&gt;
                                        &lt;!&ndash;                                                        </v-treeview>&ndash;&gt;
                                    </div>
                                </v-list-item>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>-->
                    <span style="color: #364eff;font-weight: bold;text-align: center;width: 100%;font-size: 25px">Coming Soon</span>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-card>
    </template>
  </v-content>
</template>
<script>
// import axios from "axios";
import ConstData from "../const/Const";
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import Const from "@/const/Const";

export default {
  name: 'Home',
  Details: true,
  props: {
    msg: String,
    ToggleMenu: String
  },
  data() {
    return {
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      ProjectRecordData: [],
      level: '',
      workAge: [],
      level_position: [],
      mednet: '',
      tabsModel: null,
      bpm: 50,
      headers: [
        {
          text: 'โครงการ',
          value: 'Project_name'
        },
        {
          text: 'เครดิต',
          value: 'General_credit'
        },
        {
          text: 'วันที่',
          value: 'JoinDate'
        }
      ],
      desserts: [
        {
          courseId: '1',
          courseName: 'อบรมภาษา Python',
          credit: '2',
          date: '20 พ.ค. 2563'
        }
      ],
      LevelData: [],
      items: [],
      dense: false,
      selectable: false,
      activatable: true,
      hoverable: true,
      openOnClick: true,
      shaped: true,
      rounded: true,
      selectedColor: 'accent',
      selectedColors: [
        'red',
        'warning lighten-2',
        'accent',
        'teal',
        'success',
      ],
    }
  },
  computed: {
    color() {
      if (this.bpm < 20) return 'red'
      if (this.bpm < 40) return 'orange'
      if (this.bpm < 60) return 'indigo'
      if (this.bpm < 80) return 'teal'
      return 'green'
    },
    bg() {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      DepartData: 'Depart/getDepart',
      Course: 'Course/getCourse',
      ProjectRecord: 'Project/getProjectRecord',
      projectData: 'Project/getProject',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectRecordData: 'Project/initProjectRecordData',
      initProjectData: 'Project/initProjectData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',
    }),
    GetPositionToShow() {
      this.level_position = []
      this.items.map((item) => {
        item.children = []
        item.status = 0
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi_view/PosCode/' + this.MeData[0].pos_id).then(res_pos => {
        if (res_pos.data) {
          this.items.map((item) => {
            if (res_pos.data.length > 1) {
              res_pos.data.map((pos_item) => {
                if (item.id == pos_item.Position_level_ms_Id) {

                  var DepData = this.DepartData.filter(item => item.dep_id == pos_item.Dep_Code)

                  if (DepData.length > 0) {
                    axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/C_position_cordi_Id/' + pos_item.Id).then(res_course => {
                      if (res_course.data) {
                        this.items.map((item) => {
                          if (res_course.data.length > 1) {
                            this.Course.map((Course_I) => {
                              res_course.data.map((res_c_item) => {
                                if (Course_I.Course_code == res_c_item.Course_code) {
                                  if (item.id == pos_item.Position_level_ms_Id) {
                                    if (DepData[0].dep_id == '35000') {
                                      item.children.push({
                                        id: parseInt(res_c_item.Id),
                                        name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                                        course: Course_I,
                                        Dep_Code: DepData[0].dep_id,
                                        C_position_cordi_Id: pos_item.Id,
                                        status: 1,
                                        children: []
                                      })
                                    } else {
                                      item.children.push({
                                        id: parseInt(res_c_item.Id),
                                        name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                                        course: Course_I,
                                        Dep_Code: DepData[0].dep_id,
                                        C_position_cordi_Id: pos_item.Id,
                                        status: 1,
                                        children: []
                                      })
                                    }

                                  }
                                }
                              })
                            })
                          } else {
                            this.Course.map((Course_I) => {
                              if (Course_I.Course_code == res_course.data.Course_code) {
                                if (item.id == pos_item.Position_level_ms_Id) {
                                  if (DepData[0].dep_id == '35000') {
                                    item.children.push({
                                      id: parseInt(res_course.data.Id),
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I,
                                      Dep_Code: DepData[0].dep_id,
                                      C_position_cordi_Id: pos_item.Id,
                                      status: 1,
                                      children: []
                                    })
                                  } else {
                                    item.children.push({
                                      id: parseInt(res_course.data.Id),
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I,
                                      Dep_Code: DepData[0].dep_id,
                                      C_position_cordi_Id: pos_item.Id,
                                      status: 1,
                                      children: []
                                    })
                                  }
                                }
                              }
                            })
                          }
                        })

                        this.level_position = this.items.filter((item) => item.children.length > 0)
                      }
                    })
                  }

                }
              })
            } else {
              if (item.id == res_pos.data.Position_level_ms_Id) {
                var DepData = this.DepartData.filter(item => item.dep_id == res_pos.data.Dep_Code)

                if (DepData.length > 0) {
                  axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/C_position_cordi_Id/' + res_pos.data.Id).then(res_course => {
                    if (res_course.data) {
                      this.items.map((item) => {
                        if (res_course.data.length > 1) {
                          this.Course.map((Course_I) => {
                            res_course.data.map((res_c_item) => {
                              if (Course_I.Course_code == res_c_item.Course_code) {
                                if (item.id == res_pos.data.Position_level_ms_Id) {
                                  if (DepData[0].dep_id == '35000') {
                                    item.children.push({
                                      id: parseInt(res_c_item.Id),
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I,
                                      Dep_Code: DepData[0].dep_id,
                                      C_position_cordi_Id: res_pos.data.Id,
                                      status: 1,
                                      children: []
                                    })
                                  } else {
                                    item.children.push({
                                      id: parseInt(res_c_item.Id),
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I,
                                      Dep_Code: DepData[0].dep_id,
                                      C_position_cordi_Id: res_pos.data.Id,
                                      status: 1,
                                      children: []
                                    })
                                  }
                                }
                              }
                            })
                          })
                        } else {
                          this.Course.map((Course_I) => {
                            if (Course_I.Course_code == res_course.data.Course_code) {
                              if (item.id == res_pos.data.Position_level_ms_Id) {
                                if (DepData[0].dep_id == '35000') {
                                  item.children.push({
                                    id: parseInt(res_course.data.Id),
                                    name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                                    course: Course_I,
                                    Dep_Code: DepData[0].dep_id,
                                    C_position_cordi_Id: res_pos.data.Id,
                                    status: 1,
                                    children: []
                                  })
                                } else {
                                  item.children.push({
                                    id: parseInt(res_course.data.Id),
                                    name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                                    course: Course_I,
                                    Dep_Code: DepData[0].dep_id,
                                    C_position_cordi_Id: res_pos.data.Id,
                                    status: 1,
                                    children: []
                                  })
                                }
                              }
                            }
                          })
                        }
                      })

                      this.level_position = this.items.filter((item) => item.children.length > 0)
                    }
                  })
                }

              }
            }
          })

        } else {
          this.items.map((item) => {
            item.name = item.LevelName
            item.children = []
          })
        }
      })
    },
    DaysInMonth(date2_UTC) {
      var monthStart = new Date(date2_UTC.getFullYear(), date2_UTC.getMonth(), 1);
      var monthEnd = new Date(date2_UTC.getFullYear(), date2_UTC.getMonth() + 1, 1);
      var monthLength = (monthEnd - monthStart) / (1000 * 60 * 60 * 24);
      return monthLength;
    },
    getAge(date_1, date_2) {
      //convert to UTC
      var arrayWorkSummary = [];
      var date2_UTC = new Date(Date.UTC(date_2.getUTCFullYear(), date_2.getUTCMonth(), date_2.getUTCDate()));
      var date1_UTC = new Date(Date.UTC(date_1.getUTCFullYear(), date_1.getUTCMonth(), date_1.getUTCDate()));


      //--------------------------------------------------------------
      var days = date2_UTC.getDate() - date1_UTC.getDate();
      if (days < 0) {

        date2_UTC.setMonth(date2_UTC.getMonth() - 1);
        days += this.DaysInMonth(date2_UTC);
      }
      //--------------------------------------------------------------
      var months = date2_UTC.getMonth() - date1_UTC.getMonth();
      if (months < 0) {
        date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
        months += 12;
      }
      //--------------------------------------------------------------
      var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();

      arrayWorkSummary.push(years);
      arrayWorkSummary.push(months);
      arrayWorkSummary.push(days);

      return arrayWorkSummary;
    },
    init() {
      this.initCourseData()
      this.initProjectData({
        perid: this.MeData[0].perid
      })
      this.initDepartData().then(res => {
        if (res) {
          this.GetPositionToShow()
        }
      })
      this.initProjectRecordData(this.MeData[0]).then(res => {
        if (res) {
          this.ProjectRecordData = []
          this.ProjectRecord.map(P_record_i => {
            this.projectData.map(project_i => {
              if (P_record_i.Project_code == project_i.Project_code) {
                this.Course.map(course_i => {
                  if (project_i.Course_code == course_i.Course_code) {
                    this.ProjectRecordData.push({
                      ...project_i,
                      ...course_i,
                      ...P_record_i,
                      JoinDate: P_record_i.Create_Time
                    })
                  }
                })
              }
            })
          })
        }
      })
    }
  },
  mounted() {
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '1'
        })

        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '1' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.maintain = false
              this.initlevelData().then(res => {
                if (res) {
                  this.level = this.levelData.filter(item => item.LevelCode == this.MeData[0].lv_id)
                  this.levelData.map((level_i, idx) => {
                    this.items.push({
                      ...level_i,
                      id: idx,
                      name: level_i.LevelName,
                      status: 0,
                      children: []
                    })
                  })
                }
              })
              this.workAge = this.getAge(new Date(this.MeData[0].date_in), new Date());
              // this.mednet = ConstData.ConnectionMedNet + '/Personal/ShowPictNew.php?pid=' + this.MeData[0].perid
              this.mednet = ConstData.ConnectionHost + '/ImageMED.php?pid=' + this.MeData[0].perid
              this.init()
            } else {
              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '1' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '1')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '1' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '1')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
          }
        })
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
